import { useMutation } from "@apollo/client";
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { useFormik } from "formik";
import { useEffect } from "react";
import SelectWithQuerySearch from "../../../../components/SelectWithQuerySearch";
import { UPDATE_ADMIN, UPDATE_MANAGER, UPDATE_SUPERVISOR, UPDATE_TEAM } from "../../../../graphql/mutations";
import { FETCH_COMPANIES, FETCH_MANAGERS, FETCH_SUPERVISORS } from "../../../../graphql/queries";

export default function EditDialog({ open, handleClose, onEdit, data }) {

    // Setting mutation
    const [updateTeam, { loading }] = useMutation(UPDATE_TEAM);

    // Setting Formik
    const { handleSubmit, handleChange, setFieldValue, values, errors, resetForm } = useFormik({
        initialValues: (data || { filters: {} }),
        onSubmit: (values) => {

            // Chamando a mutation de edição
            updateTeam({
                variables: {
                    id: values.id,
                    supervisor_id: values.supervisor && values.supervisor.id,
                    name: values.name
                }
            }).then(() => {
                onEdit();
            })

        }
    });
    
    useEffect(function () {
        if (data) {
            resetForm();
            setFieldValue('id', data.id);
            setFieldValue('name', data.name);
            setFieldValue('email', data.email);
            
            if(data.supervisor)
                setFieldValue('supervisor', { id: data.supervisor.id, name: data.supervisor.user.name});
        }
    }, [data]);
    
    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                scroll="paper"
                maxWidth="sm"
                fullWidth={true}
            >
                <DialogTitle id="scroll-dialog-title">Editar equipe</DialogTitle>

                <DialogContent style={{padding: 16}}>

                    <SelectWithQuerySearch
                        title="Líder"
                        query={FETCH_SUPERVISORS}
                        fetchResult="fetchSupervisors"
                        onChange={(supervisor) => { setFieldValue('supervisor', supervisor) }}
                        fullWidth
                        value={values.supervisor}
                    />

                    <TextField
                        variant="outlined"
                        margin="normal"
                        onChange={handleChange}
                        value={values.name}
                        required
                        fullWidth
                        id="name"
                        label="Nome"
                        name="name"
                        autoFocus
                        error={errors.name && true}
                        helperText={errors.name}
                    />


                </DialogContent>

                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={handleSubmit} variant="contained" color="primary" disabled={values.name == "" || loading}>
                        {loading && <CircularProgress size={14} style={{ marginRight: 12 }} />}
                        Salvar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
